import React from 'react';
import { i18nIntl } from '../../lib/ep';
import { injectIntl } from 'react-intl';
import { useCSS } from '../../lib/hooks';

const GameContainerHeader = (props) => {
	useCSS('comp/games_header.css');

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const countdown = props?.countdown ?? false;
	const attempts = props?.attempts ?? false;
	const hurry_up_attempts = (attempts !== false) ? (props?.hurry_up_attempts ?? false) : false;
	const score = props?.score ?? false;
	const round = props?.round ?? false;
	const custom_block = props?.custom_block ?? false;

	return (
		<>
			<div class="gui_game_simple_header gui_main_text_color_on_bg">
				{(countdown !== false) && (
					<div class="time_counter header_block">
						<strong class="label">{i18n(props?.time_label ?? "***Time")}</strong>

						{countdown}
					</div>
				)}

				{(custom_block !== false) && (
					custom_block
				)}

				{(attempts !== false) && (
					<div class={`gui_total_attempts header_block${(hurry_up_attempts) ? ' hurry_up' : ''}`}>
						<strong class="label">{i18n("Moves")}</strong>

						{attempts}
					</div>
				)}

				{(round !== false) && (
					<div class="round_number header_block">
						<strong class="label">{i18n(props?.round_label ?? "Round")}</strong>

						{round}
					</div>
				)}

				{(score !== false) && (
					<div class="gui_total_points header_block">
						<strong class="label">{i18n(props?.score_label ?? "Score")}</strong>

						{score}
					</div>
				)}
			</div>

			{(props.children) && (
				props.children
			)}
		</>
	)
};

export default injectIntl(GameContainerHeader);